const contactsRowTemplate = {
  text: 'Owner',
  type: 'contacts',
  columnSize: 4,
  questions: [
      {
          "labelId": "contact.first",
          id: undefined,
          alias: 'contact.first',
          name: 'First Name',
          value: '',
          type: 'string'
      },
      {
          "labelId": "contact.last",
          id: undefined,
          alias: 'contact.last',
          name: 'Last Name',
          type: 'string',
      },
      {
          "labelId": "ercContactsOwnership.percentOwnership",
          id: undefined,
          alias: 'ercContactsOwnership.percentOwnership',
          name: '% of Ownership',
          type: 'number',
      }
  ],
}
const newBusinessHeaderTemplate = {
  questions: [
      {
          "labelId": "additionalBorrower.name",
          "id": undefined,
          "borrowerId": undefined,
          "value": undefined,
          "alias": "additionalBorrower.borrower.name",
          "name": "Business Name",
          "type": "string",
      },
      {
          "labelId": "additionalBorrower.average_employees_2019",
          "borrowerId": undefined,
          "value": undefined,
          "name": "Average 2019 Employees",
          "alias": "additionalBorrower.average_employees_2019",
          "type": "number",
          "helpText": "Do you have W-2 employees?",
      }
  ]
}

const newBusinessRowTemplate = {
  text: 'Owner',
  columnSize: 6,
  questions: [
      {
          "labelId": "parentContact.id",
          alias: 'parentContact.id',
          name: 'Owner',
          value: '',
          options: [],
          type: 'select',
          placeholder: 'Select Owner',
          disableOnStoreRow: true
      },
      {
          "labelId": "ercContactsOwnership.percentOwnership",
          id: undefined,
          alias: 'ercContactsOwnership.percentOwnership',
          name: '% of Ownership',
          type: 'number',
      }
  ],
}

const spouseOwnedBusinessesRowTemplate = {
  text: 'Spouse Business',
  columnSize: 4,
  questions: [
    {
      id: undefined,
      alias: 'borrower.name',
      name: 'Business Name',
      value: '',
      type: 'string'
    },
    {
      id: undefined,
      alias: 'contacts.spouseName',
      name: 'Spouse Full Name',
      type: 'string'
    },
    {
      id: undefined,
      alias: 'ercContactsOwnership.percentOwnership',
      name: 'Percent of Ownership',
      type: 'number'
    },
    {
      id: undefined,
      alias: 'contactsFamily.ownerContactId',
      name: 'Married to',
      type: 'select'
    }
  ]
}

const relatedOwnersRowTemplate = {
text: 'Owner',
columnSize: 4,
questions: [
  {
    id: undefined,
    alias: 'relatedOwners.owner1',
    name: 'Owner',
    type: 'select',
    options: []
  },
  {
    id: undefined,
    alias: 'relatedOwners.relationship',
    name: 'Relation',
    type: 'select',
    options: [{
      "label": "Spouse",
      "value": "spouse",
    },{
      "label": "A child or a descendant of a child",
      "value": "childOrDescendant",
    }, {
      "label": "A brother, sister, stepbrother, or stepsister",
      "value": "sibling",
    }, {
      "label": "The father or mother, or an ancestor of either",
      "value": "parentOrAncestor",
    }, {
      "label": "A stepfather or stepmother",
      "value": "stepParent",
    }, {
      "label": "A niece or nephew",
      "value": "nieceOrNephew",
    }, {
      "label": "An aunt or uncle",
      "value": "auntOrUncle",
    }, {
      "label": "A son-in-law, daughter-in-law, father-in-law, mother-in-law, brother-in-law, or sister-in-law",
      "value": "inLaw",
    }, {
      "label": "Other member of household",
      "value": "otherMemberOfHousehold",
    }],
  },
  {
    id: undefined,
    alias: 'relatedOwners.owner2',
    name: 'Owner',
    options: [],
    type: 'select'
  }
],
}


const ownerRelatedEmployeesRowTemplate = {
text: 'Related Employees',
columnSize: 4,
questions: [
  {
    id: undefined,
    alias: 'ownerRelatedEmployees.employee1',
    name: 'Employee',
    value: '',
    type: 'string'
  },
  {
    id: undefined,
    alias: 'ownerRelatedEmployees.relationship',
    name: 'Relationship',
    options: [{
      "label": "Spouse",
      "value": "spouse",
    },{
      "label": "A child or a descendant of a child",
      "value": "childOrDescendant",
    }, {
      "label": "A brother, sister, stepbrother, or stepsister",
      "value": "sibling",
    }, {
      "label": "The father or mother, or an ancestor of either",
      "value": "parentOrAncestor",
    }, {
      "label": "A stepfather or stepmother",
      "value": "stepParent",
    }, {
      "label": "A niece or nephew",
      "value": "nieceOrNephew",
    }, {
      "label": "An aunt or uncle",
      "value": "auntOrUncle",
    }, {
      "label": "A son-in-law, daughter-in-law, father-in-law, mother-in-law, brother-in-law, or sister-in-law",
      "value": "inLaw",
    }, {
      "label": "Other member of household",
      "value": "otherMemberOfHousehold",
    }],
    type: 'select'
  },
  {
    id: undefined,
    alias: 'ownerRelatedEmployees.owner1',
    name: 'Related to',
    options:[],
    value: '',
    type: 'select'
  }
],
}

const ownersTemplate = {
  text: 'Owner',
  type: 'contacts',
  columnSize: 4,
  questions: [
      {
          "labelId": "owners.first",
          id: undefined,
          alias: 'owners.first',
          name: 'First Name',
          value: '',
          type: 'string'
      },
      {
          "labelId": "owners.last",
          id: undefined,
          alias: 'owners.last',
          name: 'Last Name',
          type: 'string',
          value: ''
      },
      {
          "labelId": "owners.email",
          id: undefined,
          alias: 'owners.email',
          name: 'Email',
          type: 'email',
          value: ''
      },
      {
          "labelId": "owners.percentOwnership",
          id: undefined,
          alias: 'owners.percentOwnership',
          name: '% of Ownership',
          type: 'percent',
          value: ''
      }
  ],
}

export { contactsRowTemplate, newBusinessRowTemplate, spouseOwnedBusinessesRowTemplate, ownerRelatedEmployeesRowTemplate, relatedOwnersRowTemplate, newBusinessHeaderTemplate, ownersTemplate }
